module.exports = __webpack_public_path__ + "img/lasource-18.42b6080d.jpg";